function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useState } from 'react';
import useAxios from '../../../../Hooks/use-axios';
import { useSelector } from 'react-redux';
var useDataEventDetails = function useDataEventDetails(eventId) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    winnreAuth = _ref.winnreAuth,
    cmsClient = _ref.cmsClient,
    isAuthenticatedProp = _ref.isAuthenticated;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    event = _useState2[0],
    setEvent = _useState2[1];
  var isAuthRedux = useSelector(function (state) {
    return state.auth.isAuthenticated;
  });
  var isAuthenticated = isAuthenticatedProp !== undefined ? isAuthenticatedProp : isAuthRedux;
  var _useAxios = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    isLoading = _useAxios.isLoading,
    error = _useAxios.error,
    fetchEventDetails = _useAxios.sendRequest;
  var getEventDetails = function getEventDetails() {
    fetchEventDetails({
      isEncryptedResponse: true,
      url: isAuthenticated ? "/winnre/user/events/".concat(eventId) : "/winnre/no-auth/events/".concat(eventId),
      method: 'get'
    }, function (data) {
      console.log('Event Details', data);
      setEvent(data);
    });
  };
  useEffect(function () {
    getEventDetails();
  }, [eventId, isAuthenticated]);
  return {
    event: event,
    isLoading: isLoading
  };
};
export default useDataEventDetails;